import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../../context/auth";
import { useLoading } from "../../../../context/loading";
const AddShift = () => {
  const navigate = useNavigate();
  const { circleLoading, setCirleLoading } = useLoading();
  const [id, setId] = useState(null);
  const { AccessData } = useUserDetails();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [shifData, setShiftData] = useState({
    name: "",
    duration: "",
    startTime: "",
    endTime: "",
    nameStatus: "unchecked",
    durationStatus: "unchecked",
    startTimeStatus: "unchecked",
    endTimeStatus: "unchecked",
  });

  const [originalshiftData, setoriginalshiftData] = useState({
    name: "",
    startTime: "",
    endTime: "",
    duration: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const onshiftSubmit = async () => {
    setCirleLoading(true);
    const query = `
          mutation CreateShift($shiftData: ShiftInput!) {
            createShift(shiftData: $shiftData) {
              shift {
                id
                name
                startTime
                endTime
                totalWorkingHours
              }
            }
          }
        `;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            shiftData: {
              name: shifData.name,

              totalWorkingHours: +shifData.duration,
            },
          },
        }),
      });

      const result = response.data.data?.createShift?.shift;
      if (result) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      }
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
        message: "Shift created successfully!",
      });
    } catch (error) {
      console.error("responseError:", error.response?.data || error);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message: error?.message || "Something went wrong!",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const oneditshiftSubmit = async () => {
    const query = `
            mutation editShift($id: ID!, $shiftData: ShiftInput!) {
  editShift(id: $id, shiftData: $shiftData) {
    shift {
      id
      name
      startTime
      endTime
      totalWorkingHours
    }
  }
}
        `;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id, // Ensure `id` is defined in your component's scope
            shiftData: {
              name: shifData.name, // `shifData` should contain name, startTime, endTime

              totalWorkingHours: shifData.duration,
            },
          },
        }),
      });

      if (response.data.data.editShift == null) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "This shift is mapped to an employee and cannot be edited",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      } else {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    } catch (error) {
      console.error("responseError:", error);

      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeleteSubmitShift();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ondeleteSubmitShift = async () => {
    const query = `
           mutation DeleteShift($id: ID!) {
  deleteShift(id: $id) {
                success
  }
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id, // Ensure `id` is defined in the component's scope
        },
      });

      const result = response.data.data.deleteShift;

      if (result.success) {
        navigate("/shift");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        console.log("Error deleting Shift:", result.message || "Unknown error");
      }
    } catch (error) {
      console.error("An error occurred while deleting the Shift:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const getInitData = async (id) => {
    setCirleLoading(true);
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `
  query getShiftById($id: ID!) {
  shiftById(id: $id) {
    id
    name
    startTime
    endTime
    totalWorkingHours
  }
}
              `;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const shiftRowData = response.data.data.shiftById;

      setShiftData({
        name: shiftRowData.name,
        startTime: shiftRowData.startTime,
        endTime: shiftRowData.endTime,
        duration: shiftRowData?.totalWorkingHours / 3600,
        nameStatus: "success",
        durationStatus: "success",
      });

      setoriginalshiftData({
        name: shiftRowData.name,
        startTime: shiftRowData.startTime,
        endTime: shiftRowData.endTime,
        duration: shiftRowData?.totalWorkingHours / 3600,
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        message:
          "We are unable to fetch the required data at this time. Please try again later. If the problem persists, please contact support.",
        state: "error",
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleShiftchange = (event) => {
    let shiftState = { ...shifData };

    switch (event.target.name) {
      case "name": {
        const alphaLengthRegex = new RegExp("^([a-zA-Z ]{1,25})$");
        shiftState[event.target.name + "Status"] = alphaLengthRegex.test(
          event.target.value?.trim()
        )
          ? "success"
          : event.target.value === ""
          ? "unchecked"
          : "error";
        break;
      }
      case "duration": {
        shiftState[event.target.name + "Status"] =
          event.target.value >= 8 && event.target.value <= 12
            ? "success"
            : "error";
        break;
      }
      case "startTime": {
        if (event.target.value?.trim()) {
          shiftState[event.target.name + "Status"] = "success";
        } else {
          shiftState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "endTime": {
        const { startTime } = shiftState;
        console.log(startTime);

        if (!startTime) {
          setSnackBar({
            ...snackBar,
            Error: true,
          });
        }

        if (event.target.value?.trim() && event.target.value > startTime) {
          shiftState[event.target.name + "Status"] = "success";
        } else {
          shiftState[event.target.name + "Status"] = "error";

          setSnackBar({
            ...snackBar,
            Error: true,
          });
        }
        break;
      }
      default:
        break;
    }

    shiftState[event.target.name] = event.target.value;
    setShiftData(shiftState);
  };

  const onAddShift = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onshiftSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const ondiscardShift = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setShiftData({
      name: originalshiftData.name,

      duration: originalshiftData.duration,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      shifData?.nameStatus === "success" &&
      shifData?.durationStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Shift details for you. This
                    may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {togglePage.view === true
                          ? "View  Shift Details"
                          : "Edit Shift Details"}
                      </MaterialTypography>
                    </Stack>
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditShift" && item.can_access
                      ) &&
                      togglePage?.view && (
                        <ButtonGroup
                          variant="outlined"
                          aria-label="button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Shift Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Shift Name <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="name"
                        placeholder="eg. Day Shift"
                        value={shifData.name}
                        onChange={handleShiftchange}
                        error={shifData.nameStatus === "error"}
                        success={shifData.nameStatus === "success"}
                        disabled={togglePage.view === true ? true : false}
                      />
                      {shifData.nameStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Shift Name should be a maximum of 25 characters long
                            and can contain alphabets.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </MaterialBox>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Shift Duration <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="duration"
                        type="number"
                        placeholder="eg. 8 or 9.7"
                        value={shifData.duration}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            /^([0-9]{1,2}|[0-9]{1,2}\.[0-9]?)?$/.test(value)
                          ) {
                            handleShiftchange(e);
                          }
                        }}
                        inputProps={{
                          min: 0,
                          max: 12,
                          step: 0.1,
                        }}
                        error={shifData.durationStatus === "error"}
                        success={shifData.durationStatus === "success"}
                        disabled={togglePage.view}
                      />

                      {shifData.durationStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Shift duration which should accept only numbers
                            minimum 8 and maximum 12.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your Shift data. This should not take much time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={ondiscardShift}
                  >
                    Discard
                  </MaterialButton>

                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={oneditshiftSubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={
                    !checkAllFields() || pageState.state === "submitting"
                  }
                  onClick={onAddShift}
                >
                  Submit
                </MaterialButton>
              ) : null}
            </MaterialBox>
          )}
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
          {
            <MaterialSnackbar
              color="error"
              position="Top"
              icon={<NotificationsIcon />}
              title="Message"
              content="start time should be lessor than end time."
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddShift;
